import React, { FC } from "react";
import { useTranslation } from 'react-i18next';

export interface ModalLieuxResumeProps {
  onLieuxResumeCloseModal: () => void;
  lieux: string[];
}

interface LieuxJour {
  date: string;
  numJour: number;
  lieux: string[];
}

const ModalLieuxResume: FC<ModalLieuxResumeProps> = ({
  onLieuxResumeCloseModal,
  lieux,
}) => {
    const { t } = useTranslation();
const parseLieux = (items: string[]): LieuxJour[] => {
  return items.map((item) => {
    const [header, ...rest] = item.split(":");

    const [date, numJour] = header.split("|");

    const lieuxText = rest.join(":").trim();

    const lieuxJour = lieuxText
      .split(" - ")
      .map((lieu) => lieu.trim())
      .filter((lieu) => lieu !== "");

    return {
      date: date?.trim() || "",
      numJour: Number(numJour),
      lieux: lieuxJour.length > 0 ? lieuxJour : [t("aucunLieuRenseigne")],
    };
  });
};

  const lieuxParJour = parseLieux(lieux);

  return (
    <div
      className="
        fixed
        inset-0
        z-[9999]

        flex
        items-center
        justify-center

        px-4
        py-6
      "
    >
      {/* OVERLAY */}
      <div
        className="
          absolute
          inset-0

          bg-neutral-950/45
          backdrop-blur-[2px]
        "
        onClick={onLieuxResumeCloseModal}
      />

      {/* MODALE */}
      <div
        className="
          relative
          z-10

          w-full
          max-w-[760px]

          max-h-[86vh]
          overflow-hidden

          rounded-[34px]

          bg-[linear-gradient(145deg,rgba(255,255,255,0.98)_0%,rgba(255,255,255,0.95)_58%,rgba(253,250,252,0.96)_100%)]
          dark:bg-[linear-gradient(145deg,rgba(15,23,42,0.98)_0%,rgba(17,24,39,0.96)_55%,rgba(10,15,28,0.98)_100%)]

          border
          border-white/80
          dark:border-white/10

          shadow-[0_28px_90px_rgba(15,23,42,0.22),0_8px_24px_rgba(124,58,237,0.08)]
          dark:shadow-[0_28px_90px_rgba(0,0,0,0.50),inset_0_1px_0_rgba(255,255,255,0.06)]
        "
      >
        {/* HALOS DISCRETS */}
        <div
          className="
            pointer-events-none
            absolute
            inset-0

           "
        />

        {/* HEADER */}
        <div
          className="
            relative
            z-10

            px-6
            pt-6
            pb-4
          "
        >
          <button
            type="button"
            onClick={onLieuxResumeCloseModal}
            className="
              absolute
              left-6
              top-6

              w-10
              h-10

              rounded-full

             bg-white/75
              dark:bg-slate-950/55

              border
              border-white/80
              dark:border-white/10

              text-neutral-700
              dark:text-white

              hover:bg-white
              dark:hover:bg-slate-900

              shadow-[0_8px_20px_rgba(15,23,42,0.08)]
               dark:shadow-[0_8px_20px_rgba(0,0,0,0.28)]

              flex
              items-center
              justify-center

              hover:scale-105

              transition
            "
          >
            <i className="las la-times text-2xl" />
          </button>

          <div className="text-center">
            <h2
              className="
                text-lg
                md:text-xl

                font-bold
                tracking-tight

                text-neutral-900
                dark:text-white
              "
            >
              {t('lieuxVisites')}
            </h2>

            <div
              className="
                mt-3
                flex
                items-center
                justify-center
                gap-1.5
              "
            >
  <span className="h-[3px] w-9 rounded-full bg-[#FF4A52]" />

  <span className="h-[5px] w-[5px] rounded-full bg-[rgba(255,74,82,0.60)]" />

  <span className="h-[3px] w-9 rounded-full bg-[rgba(255,74,82,0.45)]" />
            </div>
          </div>
        </div>

        {/* CONTENU */}
        <div
          className="
            relative
            z-10

            px-6
            md:px-10
            pb-8

            overflow-y-auto
            max-h-[68vh]
          "
        >
          <div
            className="
              relative
              mx-auto
              max-w-[560px]
              pt-4
            "
          >
            {lieuxParJour.map((jour, index) => {
              const isLast = index === lieuxParJour.length - 1;

              return (
                <div
                  key={`${jour.date}-${index}`}
                  className="
                    relative
                    grid
                    grid-cols-[44px_minmax(0,1fr)]
                    gap-3
                  "
                >
                  <div
  className="
    relative
    flex
    justify-center
  "
>
  {!isLast && (
  <div
    className="
      absolute
      left-1/2
      top-6
      bottom-0

      w-[2px]
      -translate-x-1/2

      bg-[#FF4A52]
      dark:bg-[#FF4A52]/80
    "
  />
)}

  <div
    className="
      relative
      z-10

      w-9
      h-9

      rounded-full
      bg-white

      border
      border-[#FF4A52]

      shadow-[0_8px_18px_rgba(255,74,82,0.10)]

      flex
      items-center
      justify-center
    "
  >
    <div
      className="
        w-6
        h-6

        rounded-full

        bg-[rgba(255,74,82,0.10)]

        flex
        items-center
        justify-center

        text-[#FF4A52]
      "
    >
      <i className="las la-map-marker-alt text-base" />
    </div>
  </div>
</div>

                  {/* CONTENU JOUR */}
                  <div
                    className={`
                      min-w-0
                      ${isLast ? "pb-0" : "pb-4"}
                    `}
                  >
                    <div
                      className="
                        inline-flex
                        items-center
                        gap-2

                        px-3
                        py-1

                        rounded-xl

                        bg-violet-50/80
                        border
                        border-violet-100

                        text-violet-700
                        text-xs
                        font-semibold

                        shadow-[0_6px_16px_rgba(124,58,237,0.06)]
                      "
                    >
                      <i className="las la-calendar text-md" />
                      <span>
                      {jour.date !== ""
                        ? jour.date
                        : `Jour ${jour.numJour}`}
                    </span>
                    </div>

                    <div
                      className="
                        mt-4

                        text-neutral-800
                        dark:text-neutral-100
                        text-base
                        md:text-sm

                        leading-relaxed
                      "
                    >
                      {jour.lieux.map((lieu, lieuIndex) => (
                        <React.Fragment key={`${jour.date}-${lieu}-${lieuIndex}`}>
                          <span
                            className="
                              inline
                              font-medium
                            "
                          >
                            {lieu}
                          </span>

                          {lieuIndex < jour.lieux.length - 1 && (
                            <span
                              className="
                                mx-3
                                inline-flex
                                h-1.5
                                w-1.5
                                translate-y-[-2px]
                                rounded-full
                                bg-rose-300
                              "
                            />
                          )}
                        </React.Fragment>
                      ))}
                    </div>

                    {!isLast && (
                      <div
                        className="
                          mt-4
                          h-px
                          w-full

                          bg-[linear-gradient(to_right,transparent,rgba(255,74,82,0.28),transparent)]
                        "
                      />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalLieuxResume;
